import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiTwotoneMail } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { useTranslation } from 'react-i18next';


function HomeAbout() {
  const { t } = useTranslation();

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            {t('let_me')}<span className="mainColor"> {t('introduce')} </span>
            </h1>
            <p className="home-about-body">
              {t('my_self_1')}
              <br />
              <br />
              {t('my_self_2')}
              <br />
              <br />
              {t("my_self_3")}
              <br />
              <br />
              {t('my_self_4')}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt
              tiltMaxAngleX={15}  
              tiltMaxAngleY={15}
              perspective={800}
              transitionSpeed={1500}
              scale={1.1}
              gyroscope={false}
            >
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1 style={{ fontSize: "2.6em" }}>
            <span className="mainColor">{t('connect')} </span>{t('with_me')}
            </h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="mailto:ejemplo@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  style={{ backgroundColor: 'transparent' }}
                >
                  <AiTwotoneMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/AdrianBaqueiro"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/adrian-baqueiro-fari%C3%B1a-a57bb4a8/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default HomeAbout;
